export default __webpack_public_path__ + "static/media/Rufina-Rivera.63cfbb76.jpg";